import { DataSourceCode } from "@syla/shared/types/models/DataSourceBase";
import { DataSource } from "../../../types/dataSource/dataSource";

export const getEstimatedSyncTime = ({ mappedToCode, code }: DataSource) =>
  (mappedToCode ?? code) == DataSourceCode.Binance
    ? "15min to 4hrs"
    : undefined;
